export class ProviderType {
    public static values: any = {
        "all": [
            "Funeral Home",
            "Crematory",
            "Mortician",
            "Body Art Establishment",
            "Body Art Temporary Event",
            "Body Artist",
            "SLP",
            "AUD",
            "OCAP",
            "HID",
            "INTRP",
            "Doula",
            "Dual AUD/SLP",
            "NAR Training Program",
            "NAR Testing Site",
            "NAR Provisional Approval",
            "Mort Intern",
            "Alkaline Hydrolysis",
            "Natural Organic Reduction",
            "SLPA",
            "TCS"
        ].sort(),
        "schedInsp": [
            "NAR Training Site",
            "Funeral Home",
            "Crematory",
            "Body Art Establishment"

        ].sort(),
        "initInsp": [
            "Body Art Establishment",
            "Body Art Temporary Event",
            "Funeral Home",
            "Crematory"
        ].sort(),
        "chow": [
            "Funeral Home",
            "Crematory"
        ].sort()
    }


    public static valuesFormB: string[] = [];
}